<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="text-center pb-3">
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="row text-center fs-14">
    <div class="col-12">
      Terms and conditions has not been accepted yet,
      <br>
      Do you want to go through that now ?
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="goToTermsAndCondition()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right m-1"> Yes
  </button>
  <button (click)="onNoClick()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right m-1"> No </button>
</mat-dialog-actions>